import { useMemo } from 'react'
import { isPendingAssistantText } from '@/constants/chat'
import { useActiveAgentQuestion } from '@/features/chat/agentQuestion/useActiveAgentQuestion.js'
import { normalizeMessages } from '@/features/chat/messageNormalize'

/**
 * @param {ReturnType<typeof import('./useChatPersistedSlices').useChatPersistedSlices>} state
 * @param {string | null} displayThreadId
 */
export function useThreadMessagesState(state, displayThreadId) {
  const { messagesByThreadId } = state

  const activeMessages = useMemo(() => {
    if (!displayThreadId) return []
    return normalizeMessages(messagesByThreadId[displayThreadId] ?? [])
  }, [messagesByThreadId, displayThreadId])

  const chatComposerLocked = useMemo(
    () => activeMessages.some((m) => m.role === 'assistant' && isPendingAssistantText(m.text)),
    [activeMessages],
  )
  const activeAgentQuestion = useActiveAgentQuestion(activeMessages)

  return { activeMessages, chatComposerLocked, activeAgentQuestion }
}
